import { useRef, useEffect } from 'react';

type AlertProps = {
  message?: string | null;
};

export const Alert = ({ message }: AlertProps) => {
  if (!message) return null;

  const targetRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (message && message.length > 0 && targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [message]);
  return (
    <div
      ref={targetRef}
      role="alert"
      aria-label={message}
      className="iLendingCDX-Alert__message"
      aria-live="assertive"
    >
      <p>{message}</p>
    </div>
  );
};
